import { useTranslation } from 'react-i18next';
import { MetodoPagamentoVendaEnum } from '../types/enums/metodo-pagamento.enum';

export const useMetodoPagamentoVendaDescricao = () => {
  const { t } = useTranslation();

  return {
    [MetodoPagamentoVendaEnum.PIX]: t('paymentMethodDescription.PIX'),
    [MetodoPagamentoVendaEnum.BOLETO]: t('paymentMethodDescription.BOLETO'),
    [MetodoPagamentoVendaEnum.CARTAO_CREDITO]: t(
      'paymentMethodDescription.CARTAO_CREDITO',
    ),
    [MetodoPagamentoVendaEnum.PAY_PAL]: 'Pay Pal',
    [MetodoPagamentoVendaEnum.APPLE_PAY]: 'Apple Pay',
    [MetodoPagamentoVendaEnum.GOOGLE_PAY]: 'Google Pay',
    [MetodoPagamentoVendaEnum.AMAZON_PAY]: t(
      'paymentMethodDescription.AMAZON_PAY',
    ),
  };
};
